<!-- Modal Overlay and Container -->
@if (isOpen && config) {
  <div class="modal-overlay" 
       (click)="onOverlayClick()" 
       [@fadeIn]
       [style.will-change]="'opacity'">
    
    <div class="modal-container {{ sizeClass }}" 
         (click)="onContentClick($event)"
         [@slideIn]
         [style.will-change]="'opacity, transform'"
         role="dialog"
         [attr.aria-labelledby]="config.showHeader ? 'modalTitle' : null"
         [attr.aria-describedby]="'modalMessage'"
         aria-modal="true">
      
      <!-- Modal Header (Optional) -->
      @if (config.showHeader && config.title) {
        <div class="modal-header" [class.modal-header-compact]="config.compactHeader === true">
          <h3 id="modalTitle" class="modal-title">{{ config.title }}</h3>
          <div class="modal-header-actions">
            @if (config.showCopyButton === true) {
              <button
                class="modal-copy-btn"
                (click)="onCopy()"
                aria-label="Copy modal content"
                type="button">
                {{ copyButtonLabel }}
              </button>
            }
            @if (config.showCloseButton) {
              <button 
                class="modal-close-btn" 
                (click)="onClose()"
                aria-label="Close modal"
                type="button">
                ×
              </button>
            }
          </div>
        </div>
      }

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Success/Info Icon for alerts -->
        @if ((config.type === ModalType.ALERT || config.type === ModalType.INFO) && config.hideInfoIcon !== true) {
          <div class="modal-icon modal-icon-success">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"/>
            </svg>
          </div>
        }

        <!-- Question Icon for confirmations -->
        @if (config.type === ModalType.CONFIRMATION) {
          <div class="modal-icon modal-icon-question">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"/>
            </svg>
          </div>
        }

        <!-- Message -->
        @if (config.message) {
          <p id="modalMessage" class="modal-message" [class.modal-message-left]="config.messageAlignLeft === true">{{ config.message }}</p>
        }

        <!-- Text Input for PROMPT type -->
        @if (config.type === ModalType.PROMPT) {
          <div class="modal-input-group">
            <textarea
              class="modal-input"
              [(ngModel)]="inputValue"
              [placeholder]="config.inputPlaceholder || 'Enter text...'"
              [rows]="config.inputRows || 3"
              autofocus></textarea>
          </div>
        }

        <!-- Details (Optional) -->
        @if (config.details && config.details.length > 0) {
          <div class="modal-details">
            @for (detail of config.details; track detail.label) {
              <div class="modal-detail-row">
                <strong>{{ detail.label }}:</strong>
                <span>{{ detail.value }}</span>
              </div>
            }
          </div>
        }
      </div>

      <!-- Modal Footer (Buttons) -->
      @if (showButtons) {
        <div class="modal-footer" 
             [class.modal-footer-confirmation]="isConfirmation"
             [class.modal-footer-list]="config.isListLayout === true">
          @if (isConfirmation) {
            <!-- Confirmation buttons (Yes/No) - shown as list for Download/Select modals -->
            <button
              class="modal-btn modal-btn-confirm"
              [class.modal-btn-danger]="config.isDanger"
              (click)="onConfirm()"
              [disabled]="isConfirmDisabled"
              type="button"
              autofocus>
              {{ config.confirmText }}
            </button>
            <button 
              class="modal-btn modal-btn-cancel" 
              (click)="onCancel()"
              [disabled]="isProcessingAction"
              type="button">
              {{ config.cancelText }}
            </button>
          } @else {
            <!-- Alert button (OK) -->
            <button 
              class="modal-btn modal-btn-primary" 
              (click)="onConfirm()"
              [disabled]="isProcessingAction"
              type="button"
              autofocus>
              {{ config.confirmText || 'OK' }}
            </button>
          }
        </div>
      }
    </div>
  </div>
}
